import Vue from "vue";

Vue.prototype.$foggiafondo = [
  {
    key: "foggiafondo0",
    variant: [
      {
        key: "foggiafondo0var0"
      },
      {
        key: "foggiafondo0var1"
      }
    ]
  },
  {
    key: "foggiafondo1",
    variant: [
      {
        key: "foggiafondo1var0"
      },
      {
        key: "foggiafondo1var1"
      },
      {
        key: "foggiafondo1var2"
      }
    ]
  },
  {
    key: "foggiafondo2",
    variant: [
      {
        key: "foggiafondo2var0"
      },
      {
        key: "foggiafondo2var1"
      },
      {
        key: "foggiafondo2var2"
      }
    ]
  }
];
